const deliveryTypes = [
	{ label: "Online", value: "ONLINE" },
	{ label: "In Person", value: "IN_PERSON" },
	{ label: "Online & In Person", value: "BOTH" },
];

export default deliveryTypes;
